import { Component, OnInit,Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// import { ClipboardService } from 'ngx-clipboard';
import { ServerService } from 'src/app/services/server.service';
import { ClipBoardService } from 'src/app/services/clipboard.service';

@Component({
  selector: 'app-task-status-remark-modal',
  templateUrl: './task-status-remark-modal.component.html',
  encapsulation:ViewEncapsulation.None,
  styleUrls: ['./task-status-remark-modal.component.scss']
})
export class TaskStatusRemarkModalComponent implements OnInit {
  task:any;
  authToken = localStorage.getItem('token');
  remarks:any;
  r_value:any = false;
  deal_value:any = '';
  effective_deal_value:any = '';
  master_budget:any = '';
  agreement_date:null;
  userInfo = JSON.parse(localStorage.getItem('userInfo'));
  btnStatus = false;
  
  dealVlueInWord: any = '';
  effectiveDealVlueInWord: any = '';
  masterCreditInWord: any = '';

  constructor(
    private dialogRef: MatDialogRef<TaskStatusRemarkModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
    private fb:FormBuilder,
    private clipBoardService: ClipBoardService,
    private _serverService:ServerService
    // @Inject(MAT_DIALOG_DATA)public data
    
  ) { 
    // console.log(this.data)
    this.task = this.data;
  }

  ngOnInit() {
    console.log(this.userInfo)
  }
  close() {
    this.dialogRef.close();
}
changeStatus(){
  this.btnStatus = true;
  // console.log("hi")
  let body;
  let task_body
   if(this.task.task_type == 'Finance Approval' && this.task.new_status.toUpperCase() == 'DONE' && this.userInfo.role == 'FinanceAdmin') {
      body = {
        "campaign_id": this.task.campaign_id,
        "status":this.task.new_status,
        "remark":this.remarks,
        "r":this.r_value,
        "deal_value":this.deal_value,
        "effective_deal_value":this.effective_deal_value,
        "master_budget":this.master_budget,
        "agreement_date":this.agreement_date

    }
    task_body = {
      "campaign_id": this.task.campaign_id,
      "status":this.task.new_status,
      "remark":this.remarks
    }
  }
    else{
      task_body = {
        "campaign_id": this.task.campaign_id,
        "status":this.task.new_status,
        "remark":this.remarks
      }
    }
    // updateCampaignDetails(url, body, token): Observable<any> {
    // console.log(body)
    // return;
    let url = this.task.id
    this._serverService.campaignTaskStatusChange(url,task_body,this.authToken).subscribe((data)=>{
      this.clipBoardService.showMessgeInText("Task Status Updated Succesfully", "success-snackbar");
      
      
      if(this.task.task_type == 'Finance Approval' && this.task.new_status.toUpperCase() == 'DONE' && this.userInfo.role == 'FinanceAdmin' ){
        body = {
          "campaign_id": this.task.campaign_id,
          // "status":this.task.new_status,
          // "remark":this.remarks,
          "r":this.r_value,
          "deal_value":this.deal_value,
          "effective_deal_value":this.effective_deal_value,
          "master_budget":this.master_budget,
          "agreement_date":this.agreement_date
  
      }
      this._serverService.updateCampaignDetails(this.task.campaign_id,body,this.authToken).subscribe((
        data)=>{
          this.dialogRef.close(data);
        },
        error => {
         console.error('Changing of Task Status failed', error);
         this.btnStatus = false;
         // this.showComponentLoader = false;
       }
      )
    }
    else{
      this.dialogRef.close(data);
    }

     
      // console.log(data)
    },err=>{
      this.clipBoardService.showMessgeInText(err, "error-snackbar")
      this.btnStatus = false;
    })
    // console.log(event.target.value)
  }

  onInputChange(event: any, type: any): any {

    let values = Number(event.target.value)

    const input = event.target as HTMLInputElement;
    const filteredValue = input.value.replace(/[^0-9]/g, '');

    if (input.value !== filteredValue) {
      input.value = filteredValue;
    }    

    var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    let minValuesWithComma:any = values;

    if ((minValuesWithComma = minValuesWithComma.toString()).length > 9) return 'overflow';

    minValuesWithComma = ('000000000' + minValuesWithComma).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);

    if (!minValuesWithComma) return; var str = '';
    str += (minValuesWithComma[1] != 0) ? (a[Number(minValuesWithComma[1])] || b[minValuesWithComma[1][0]] + ' ' + a[minValuesWithComma[1][1]]) + 'crore ' : '';
    str += (minValuesWithComma[2] != 0) ? (a[Number(minValuesWithComma[2])] || b[minValuesWithComma[2][0]] + ' ' + a[minValuesWithComma[2][1]]) + 'lakh ' : '';
    str += (minValuesWithComma[3] != 0) ? (a[Number(minValuesWithComma[3])] || b[minValuesWithComma[3][0]] + ' ' + a[minValuesWithComma[3][1]]) + 'thousand ' : '';
    str += (minValuesWithComma[4] != 0) ? (a[Number(minValuesWithComma[4])] || b[minValuesWithComma[4][0]] + ' ' + a[minValuesWithComma[4][1]]) + 'hundred ' : '';
    str += (minValuesWithComma[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(minValuesWithComma[5])] || b[minValuesWithComma[5][0]] + ' ' + a[minValuesWithComma[5][1]]) + 'only ' : '';

    if (type == 'dealValue') {
      this.dealVlueInWord = str;
    }

    if (type == 'effectiveDealVlue') {
      this.effectiveDealVlueInWord = str;
    }

    if (type == 'masterCredit') {
      this.masterCreditInWord = str;
    }

}

}